import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Contact.css";
import ContactUs from "./ContactUs";
import ContactForm from "../../components/ContactForm/ContactForm";

const Contact = () => {
  const location = useLocation();

  const [contactUsType, setContactUsType] = useState("other");
  useEffect(() => {
    setContactUsType(location.state.contactType);
  }, [contactUsType]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id="contact" className="container-fluid c-wrapper">
      <div className="contact-navbar"></div>
      <div className="paddings contact-us-container">
        <div className="row contact-roww">
          <div className="col-lg-6 c-left-column">
            <ContactUs
              contactTitle="Reach Out to Us to Assemble Your Team!"
              contactImg="./house.png"
              altHouse="House"
              address="No 13, Maitama Sule Street, Off Raymond Njoku S/W Ikoyi, Lagos
              "
              phone="./call.png"
              altPhn="Phone"
              phnNumber="+234-902-876-2111"
              logoImg1="./linkedin-with-bg.png"
              logoImg2="./twitter-with-bg.png"
              altLogo1="LinkedIn"
              altLogo2="Twitter"
            />
          </div>
          <div className="col-lg-6 c-right-column">
            <ContactForm helpType={contactUsType} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
